import { Component, ViewChild, TemplateRef, AfterViewInit, ChangeDetectorRef, ElementRef, OnDestroy } from '@angular/core';
import { MatRowDef, MatTableModule } from '@angular/material/table';
import { MatDialogModule, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatSelectModule } from '@angular/material/select';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { CompanyAttributes } from '@albatrosdeveloper/ave-models-package';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CompanyService } from '../../configuration/company/company.service.service';
import { ICreatePaymentCondition } from './interfaces/create-payment-condition.interface';
import { IUpdatePaymentCondition } from './interfaces/update-payment-condition.interface';
import { PaymentConditionService } from './payment-condition.service';
import PaymentConditionAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/payment-condition/payment-condition.entity';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { PaymentConditionTypeEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/payment-condition-type.enum';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { TranslocoModule } from '@ngneat/transloco';
import { getCode } from 'app/utils/method';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { Subscription } from 'rxjs';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { FinanceFiltersComponent } from '../../filters/finance-filters/finance-filters.component';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { IFilters } from '../../filters/interfaces/filterInterface';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";


@Component({
  selector: 'app-payment-condition',
  templateUrl: './payment-condition.component.html',
  styleUrls: ['./payment-condition.component.scss'],
  standalone: true, 
  imports: [
    TranslocoModule,
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgSelectComponent,
    NgSelectModule,
    MatTabsModule,
    FilterComponent,
    FinanceFiltersComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective
    // BrowserAnimationsModule,
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
})
export class PaymentConditionComponent implements AfterViewInit, OnDestroy {
  getCode = getCode;
  displayedColumns: string[] = ["name", "type", "actions"];
  currentCreatePaymentCondition: ICreatePaymentCondition = this.initializeCreatePaymentCondition();
  currentUpdatePaymentCondition: PaymentConditionAttributes | undefined;

  dataSource: PaymentConditionAttributes[] = [];
  companyList: CompanyAttributes[] = [];
  selectedCompanyIds: string[] = [];
  paymentTypeList: string [] = Object.values(PaymentConditionTypeEnum)

  searchQuery: string = '';
  totalItems: number = 0;
  pageSize: number = 50;
  pageIndex: number = 0;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;
 
  //BUSCADOR
  searchSubscription: Subscription;
  form: FormGroup
  selectedStatuses: number [] = [];

  // Lazy loading flags
  loadFiltersData = false;
  private companiesLoaded = false;

  constructor(
    private readonly paymentConditionService: PaymentConditionService,
    private companyService: CompanyService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      companyId: [],
      paymentModelId: []
    });
   }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
    // Companies will be loaded lazily when modals are opened
  }


  private fetchAllCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res) => {
        this.companyList = res.data;
        this.companiesLoaded = true;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener compañias.","Cerrar",{ duration: 5000});
      },
    });
  }

  private ensureCompaniesLoaded(): void {
    if (!this.companiesLoaded) {
      this.fetchAllCompanies();
    }
  }


  private initializeCreatePaymentCondition(): ICreatePaymentCondition {
    return { code: "", name: "", companyId: "", daysToPay: 0, type: "" };
  }


  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  findAllWithCount(): void {
    const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" = this.sort.direction === "asc" ? "ASC" : "DESC";
    const companyCodes = this.getSelectedCompanyCodes(this.selectedCompanyIds);
      let filter: IFilters = {
      companyId: this.form.get("companyId")?.value,
      paymentModelId: this.form.get("paymentModelId")?.value,
      status: this.selectedStatuses.length ? this.selectedStatuses : null
      
    }
    this.paymentConditionService
      .findAllWithCount(
        { currentPage: pageIndex, limitPerPage: this.pageSize, search: this.searchQuery, sort: sortField, sortDirection: sortDirection },filter
      )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof PaymentConditionAttributes {
    const validSortFields: (keyof PaymentConditionAttributes)[] = ["name", "type", "statusId"];
    return validSortFields.includes(this.sort.active as keyof PaymentConditionAttributes) ? (this.sort.active as keyof PaymentConditionAttributes) : "name";
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.findAllWithCount();
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }
   
  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.paginator.pageIndex = 0;
          this.findAllWithCount();
        }
      });
  }

  trackByFn(index: number, item: PaymentConditionAttributes): string {
    return item._id.toString();
  }

  getTypeLabel(type: string): string {
    const labels = {
      [PaymentConditionTypeEnum.CREDIT]: 'Crédito',
      [PaymentConditionTypeEnum.DEBIT]: 'Contado',
    };
    return labels[type] || type;
  }
  
  openCreateModal(): void {
    this.ensureCompaniesLoaded();
    this.currentCreatePaymentCondition = this.initializeCreatePaymentCondition();
    this.dialogRefAdd = this.dialog.open(this.addModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createPaymentCondition());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openEditModal(condition: PaymentConditionAttributes): void {
    this.ensureCompaniesLoaded();
    this.currentUpdatePaymentCondition = { ...condition,
      externalKeys: {
        code: condition?.externalKeys?.code ?? null,
        }
     };
    this.dialogRefEdit = this.dialog.open(this.editModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updatePaymentCondition(condition._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  createPaymentCondition(): void {
    this.paymentConditionService.create(this.currentCreatePaymentCondition).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
        this.dialogRefAdd.close()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updatePaymentCondition(id: string): void {
    if (this.currentUpdatePaymentCondition) {
      const updatedPaymentCondition: IUpdatePaymentCondition = { ...this.currentUpdatePaymentCondition,
        companyId: this.currentUpdatePaymentCondition.company._id.toString(),
       };

      this.paymentConditionService.update(id, updatedPaymentCondition).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          this.findAllWithCount();
          this.dialogRefEdit.close()
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(event: boolean, condition: PaymentConditionAttributes): void {
    const originalStatusId = condition.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedPaymentCondition = { ...condition, statusId: updatedStatusId };

    this.paymentConditionService.update(condition._id.toString(), updatedPaymentCondition).subscribe({
      next: () => {
        this.findAllWithCount();
      },
      error: () => {
        condition.statusId = originalStatusId; // Volver al estado original si falla
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
      }
    });
  }

  openDeleteDialog(condition: PaymentConditionAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: condition, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(condition._id.toString()));
  }

  delete(id: string): void {
    this.paymentConditionService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  
  onCompanySelectionChange(companyId: string): void {
    if (this.currentUpdatePaymentCondition) {
      this.currentUpdatePaymentCondition.company = this.companyList.find(
        (company) => company._id.toString() === companyId
      )!;
    }
  }

  getSelectedCompanyCodes(selectedCompanyIds: string[]): number[] {
    return selectedCompanyIds.map(
      (id) => this.companyList.find((group) => group._id.toString() === id)?.id
    );
  }

  clearFilters(): void {
    this.selectedCompanyIds = [];
    this.searchQuery = "";
    this.form.reset({
      companyId: [],
      paymentModelId: []
    });
    this.findAllWithCount();
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
